import { PRODUCT_NAME } from "../lib/labels";
import { Button } from "./ui";

/** 入れなかったとき（503・つながらない）の画面。案内と再試行のボタンだけ */
export function ConnectFailed({ reason, onRetry }: { reason?: string; onRetry(): void }) {
  return (
    <div className="gate" data-testid="connect-failed">
      <div className="gate-band">
        <div className="gate-brand">
          <img src="/img/logo-agentic-white.webp" width={480} height={145} alt="Agentic" />
          <span className="gate-name">{PRODUCT_NAME}</span>
        </div>
      </div>
      <main className="gate-main">
        <div className="gate-body stack">
          <h1>接続できません</h1>
          <p>{reason ?? "再読み込みしてください。"}</p>
          <Button variant="primary" icon="sync" data-testid="connect-retry" onClick={onRetry}>
            再試行
          </Button>
        </div>
      </main>
    </div>
  );
}
